import { fieldHeight, fieldPadding, fieldWidth } from "../constants/fieldVars";

export const convertCoordinatesWithPadding = (x, y) => {
    const scaleX = (fieldWidth - 2 * fieldPadding) / 104; // Adjust the scale factor to account for padding
    const scaleY = (fieldHeight - 2 * fieldPadding) / 70;
    return {
        x: fieldPadding + x * scaleX,
        y: fieldHeight - fieldPadding - y * scaleY, // Invert the y-coordinate and adjust for padding
    };
};